import Vue from 'vue';

export default (i18n) => {
  const vue = new Vue({
    el: '#price-chart',
    i18n,
    template: '<price-chart />',
    components: {
      PriceChart: () => import('./main'),
    },
    async beforeCreate() {
      await Promise.all(['main', 'stock_info', 'building_page', 'transaction'].map(async (section) => {
        const respZh = await fetch(`/ics/property/lang/zh/${section}`);
        this.$i18n.mergeLocaleMessage('zh', {
          [section]: await respZh.json(),
        });

        const respEn = await fetch(`/ics/property/lang/en/${section}`);
        this.$i18n.mergeLocaleMessage('en', {
          [section]: await respEn.json(),
        });
      }));

      switch (window.lang) {
        case 'english':
          this.$i18n.locale = 'en';
          break;
        case 'gb':
          this.$i18n.locale = 'gb';
          break;
        default:
          this.$i18n.locale = 'zh';
      }
    },
  });

  return vue;
};
